export const brandState = {
  brandName: "",
  brandDescription: "",
  brandLogo: null,
  brandcode:"",
  brandcodeStatus:"unchecked",
  brandNameStatus: "unchecked",
  brandDescriptionStatus: "unchecked",
  brandLogoStatus: false,
};

export const brandStateMange = (state, action) => {
  
  const inputName = action?.name;
  console.log(inputName,"inputName");
  
  const value = action?.value;

  switch (inputName) {
    case "brandName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,1000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          brandName: value,
          brandNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brandName: "",
          brandNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          brandName: value,
          brandNameStatus: "error",
        };
      }
    }

    case "brandCode": {

      
      const alphaNLenghthRegex = new RegExp("^(.{1,1000})$");
      if (alphaNLenghthRegex.test(value) && value!=undefined) {
        
        return {
          ...state,
          brandCode: value,
          brandCodeStatus: "success",
        };
      } else if (!value) {

       
        
        return {
          ...state,
          brandCode: "",
          brandCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          brandCode: value,
          brandCodeStatus: "error",
        };
      }
    }

    case "brandDescription": {
     const alphaNLenghthRegex = new RegExp("^.{1,10000}$", "s");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          brandDescription: value,
          brandDescriptionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brandDescription: "",
          brandDescriptionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          brandDescription: value,
          brandDescriptionStatus: "error",
        };
      }
    }

    case "brandLogo": {
      if (value) {
        return {
          ...state,
          brandLogo: value,
          brandLogoStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          brandLogo: null,
          brandLogoStatus: false,
        };
      }
    }

    default:
      return state;
  }
};
